"use client";

import React from "react";
import { toast as sonnerToast } from "sonner";

interface ToastProps {
  id: string | number;
  title: string;
  description: string;
  variant: "success" | "error" | "info";
  button?: {
    label: string;
    onClick: () => void;
  };
}

export function toast(toast: Omit<ToastProps, "id">) {
  return sonnerToast.custom((id) => (
    <Toast
      id={id}
      title={toast.title}
      description={toast.description}
      variant={toast.variant}
      button={toast.button}
    />
  ));
}

function Toast(props: ToastProps) {
  const { title, description, button, id, variant } = props;

  const variantStyles = {
    success: {
      bg: "bg-primary",
      text: "text-black",
      hover: "hover:bg-primary/80",
    },
    error: {
      bg: "bg-red-300",
      text: "text-red-900",
      hover: "hover:bg-red-100",
    },
    info: {
      bg: "bg-blue-300",
      text: "text-blue-900",
      hover: "hover:bg-blue-100",
    },
  };

  const styles = variantStyles[variant];

  return (
    <div
      className={`flex w-full md:w-[364px] items-center p-5 border border-dashed border-black ${styles.bg} rounded-3xl`}
    >
      <div className="flex flex-1 items-center">
        <div className="w-full">
          <p className="text-sm font-medium text-gray-900 font-poppins">
            {title}
          </p>
          <p className="mt-1 text-sm text-gray-800">{description}</p>
        </div>
      </div>
      {button && (
        <div className="ml-5 shrink-0">
          <button
            className={`rounded px-3 py-1 text-sm font-semibold ${styles.bg} ${styles.text} ${styles.hover}`}
            onClick={() => {
              button.onClick();
              sonnerToast.dismiss(id);
            }}
          >
            {button.label}
          </button>
        </div>
      )}
    </div>
  );
}

export default Toast;
